import { Pipe, PipeTransform } from '@angular/core';
import { CleanFillUserStatus, CompanyQPTotalType } from '@services/cleanfill-api/cleanfill-api.generated';

@Pipe({
  name: 'userStatus'
})
export class UserStatusPipe implements PipeTransform {
  transform<T>(value: CleanFillUserStatus | CompanyQPTotalType | number): string {
    switch (value) {
      case 0:
      case CleanFillUserStatus.Active:
        return 'Active';
      case 1:
      case CleanFillUserStatus.Deactivated:
        return 'Deactived';
      case 2:
      case CleanFillUserStatus.PendingVerification:
        return 'Pending Verification';
      case 3:
      case CleanFillUserStatus.PendingSetUp:
        return 'Pending Setup';
      case 4:
      case CompanyQPTotalType.PendingRequest:
        return 'Pending Request';
      case 5:
      case CompanyQPTotalType.Active:
        return 'Active';
      case CompanyQPTotalType.Rejected:
        return 'Rejected';
      case 6:
      case CompanyQPTotalType.AllStatus:
        return 'AllStatus';
    }
    return '';
  }
}
